export const FLOATING_ICON_SIZE = 14;
export const FIXED_ICON_SIZE = 14;
export const EMOJI_ICON_SIZE = 14;
